import { createAction } from '@reduxjs/toolkit';

import { sessionActions } from 'intakeOptimization/store/session/reducers';

import t from './types';

export const getSessionToken = createAction<string>(t.GET_SESSION_TOKEN);
export const { setSessionData } = sessionActions;
